<template>
  <div
    class="rounded-xl p-4 shadow hover:shadow-xl transition-shadow cursor-pointer border-t-[2px] border-black h-full flex flex-col justify-between"
  >
    <!-- Content Section -->
    <div class="bg-white text-black rounded-lg flex flex-col justify-between h-full">
      <div class="mt-4 flex-1">
        <p class="text-left text-xs">{{ query.description.main }}</p>
      </div>

      <!-- See Details Button -->
      <div class="flex justify-center mt-4">
        <button
          @click="goToDetails"
          class="bg-[#157813] hover:bg-[#296b1e] text-white px-3 py-2 rounded-lg hover:shadow-lg transition-all text-sm font-bold"
        >
          See Details
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Query } from "@/models/Query";
import { defineComponent, PropType } from "vue";
import { useRouter } from "vue-router";

export default defineComponent({
  props: {
    query: {
      type: Object as PropType<Query>,
      required: true,
    },
  },
  setup(props) {
    const router = useRouter();
    const goToDetails = () => {
      router.push(`/query/${props.query.id}`);
    };

    return { goToDetails };
  },
});
</script>

<style scoped>
/* Ensure consistent card dimensions */
.rounded-xl {
  min-height: 200px; /* Adjust to your preferred height */
  display: flex;
  flex-direction: column;
}

/* Button */
button {
  transition: all 0.3s ease-in-out;
}

button:hover {
  transform: scale(1.05);
}

/* Text Inside */
.text-white {
  text-shadow: 0.5px 0.5px 1px #000;
}
</style>
